import { useState } from 'react'
import HeaderLine from "../../components/headerLine/HeaderLine";
import TrackingHamMenu from "./trackingHamMenu/TrackingHamMenu";

export default function PageTrackingSubMenu(props) {
    const [hamShowed, showHam] = useState(true)

    function onHamClicked() {
        showHam(!hamShowed);
    }

    return (
        <div className="page-tracking fullpage">
            <HeaderLine
                selectedPage={"tracking"}
                onHamClicked={onHamClicked}
            />

            <main>
                <aside>
                    <TrackingHamMenu
                        show={hamShowed}
                    />
                </aside>
            </main>
        </div>
    )
}